module.exports = __webpack_public_path__ + "img/logo.b004ae08.png";